export const echartsDefaultTheme = {
    "name":'default',
    "seriesCnt": 3,
    "backgroundColor": "rgba(0,0,0,0)",
    "titleColor": "#333333",
    "subtitleColor": "#aaa",
    "textColorShow": false,
    "textColor": "#333",
    "markTextColor": "#eee",
    "color": [
        "#7A7AFC",
        "#FFBA02",
        "#F7747B",
        "#d48265",
        "#91c7ae",
        "#749f83",
        "#ca8622",
        "#bda29a",
        "#6e7074",
        "#546570",
        "#c4ccd3"
    ],
    "borderColor": "#ccc",
    "borderWidth": 0,
    "visualMapColor": [
        "#bf444c",
        "#d88273",
        "#f6efa6"
    ],
    "legendTextColor": "#333333",
    "kColor": "#7A7AFC",
    "kColor0": "#314656",
    "kBorderColor": "#7A7AFC",
    "kBorderColor0": "#314656",
    "kBorderWidth": 1,
    "lineWidth": 2,
    "symbolSize": 4,
    "symbol": "emptyCircle",
    "symbolBorderWidth": 1,
    "lineSmooth": false,
    "graphLineWidth": 1,
    "graphLineColor": "#aaa",
    "mapLabelColor": "#000000",
    "mapLabelColorE": "rgb(100,0,0)",
    "mapBorderColor": "#444444",
    "mapBorderColorE": "#444",
    "mapBorderWidth": 0.5,
    "mapBorderWidthE": 1,
    "mapAreaColor": "#eeeeee",
    "mapAreaColorE": "rgba(255,215,0,0.8)",
    "axes": [
        {
            "type": "all",
            "name": "通用坐标轴",
            "axisLineShow": true,
            "axisLineColor": "#333",
            "axisTickShow": true,
            "axisTickColor": "#333",
            "axisLabelShow": true,
            "axisLabelColor": "#333",
            "splitLineShow": true,
            "splitLineColor": [
                "#ccc"
            ],
            "splitAreaShow": false,
            "splitAreaColor": [
                "rgba(250,250,250,0.3)",
                "rgba(200,200,200,0.3)"
            ]
        },
        {
            "type": "category",
            "name": "类目坐标轴",
            "axisLineShow": true,
            "axisLineColor": "#333",
            "axisTickShow": true,
            "axisTickColor": "#333",
            "axisLabelShow": true,
            "axisLabelColor": "#333",
            "splitLineShow": false,
            "splitLineColor": [
                "#ccc"
            ],
            "splitAreaShow": false,
            "splitAreaColor": [
                "rgba(250,250,250,0.3)",
                "rgba(200,200,200,0.3)"
            ]
        },
        {
            "type": "value",
            "name": "数值坐标轴",
            "axisLineShow": true,
            "axisLineColor": "#333",
            "axisTickShow": true,
            "axisTickColor": "#333",
            "axisLabelShow": true,
            "axisLabelColor": "#333",
            "splitLineShow": true,
            "splitLineColor": [
                "#ccc"
            ],
            "splitAreaShow": false,
            "splitAreaColor": [
                "rgba(250,250,250,0.3)",
                "rgba(200,200,200,0.3)"
            ]
        },
        {
            "type": "log",
            "name": "对数坐标轴",
            "axisLineShow": true,
            "axisLineColor": "#333",
            "axisTickShow": true,
            "axisTickColor": "#333",
            "axisLabelShow": true,
            "axisLabelColor": "#333",
            "splitLineShow": true,
            "splitLineColor": [
                "#ccc"
            ],
            "splitAreaShow": false,
            "splitAreaColor": [
                "rgba(250,250,250,0.3)",
                "rgba(200,200,200,0.3)"
            ]
        },
        {
            "type": "time",
            "name": "时间坐标轴",
            "axisLineShow": true,
            "axisLineColor": "#333",
            "axisTickShow": true,
            "axisTickColor": "#333",
            "axisLabelShow": true,
            "axisLabelColor": "#333",
            "splitLineShow": true,
            "splitLineColor": [
                "#ccc"
            ],
            "splitAreaShow": false,
            "splitAreaColor": [
                "rgba(250,250,250,0.3)",
                "rgba(200,200,200,0.3)"
            ]
        }
    ],
    "axisSeperateSetting": true,
    "toolboxColor": "#999999",
    "toolboxEmphasisColor": "#666666",
    "tooltipAxisColor": "#cccccc",
    "tooltipAxisWidth": 1,
    "timelineLineColor": "#293c55",
    "timelineLineWidth": 1,
    "timelineItemColor": "#293c55",
    "timelineItemColorE": "#a9334c",
    "timelineCheckColor": "#e43c59",
    "timelineCheckBorderColor": "rgba(194,53,49, 0.5)",
    "timelineItemBorderWidth": 1,
    "timelineControlColor": "#293c55",
    "timelineControlBorderColor": "#293c55",
    "timelineControlBorderWidth": 0.5,
    "timelineLabelColor": "#293c55",
    "datazoomBackgroundColor": "rgba(47,69,84,0)",
    "datazoomDataColor": "rgba(47,69,84,0.3)",
    "datazoomFillColor": "rgba(167,183,204,0.4)",
    "datazoomHandleColor": "#a7b7cc",
    "datazoomHandleWidth": "100",
    "datazoomLabelColor": "#333333"
}
